import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { Grid, Icon, Typography } from 'gu-ui-kit'
import React from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

const AdmitadWarning = () => {
  const { t } = useTranslation()

  return (
    <Grid
      className={clsx(styles['billing__notification'], styles['billing__notification_notice'])}
      direction={'row'}
      wrap={false}
      gap={16}
    >
      <Icon
        size={'m'}
        name={'status warning'}
        color={'Accent-Notice-Secondary'}
      />
      <Grid
        direction={'column'}
        gap={4}
      >
        <Typography variant={'Subtitle-20'}>
          {t('billing::payment_method_warning_message.heading')}
        </Typography>
        <div>
          <Typography
            component={'span'}
            variant={'Body-20'}
            dangerouslySetInnerHTML={{
              __html: t('billing::admitad_warning_message'),
            }}
          />
        </div>
      </Grid>
    </Grid>
  )
}

AdmitadWarning.propTypes = {}

export default AdmitadWarning
